import { memo } from 'react';

import TableColumnClickableText from '@/components/ui/table/TableColumnClickableText';
import { truncateText } from '@bitstopco/bitstop-theme/helpers';

import { NOT_AVAILABLE } from '@/constants/app/config';

import type { MachinesCashLog } from '@/types';
import type { ClickableTextProps } from '@bitstopco/bitstop-theme';

type Props = {
  data: MachinesCashLog;
  link?: boolean;
  fixIcon?: ClickableTextProps['fixIcon'];
  truncate?: ClickableTextProps['truncate'];
};

const TableColumnCashLogMachine = ({ data, link, fixIcon, truncate }: Props) => {
  const id = String(data.atm_id || NOT_AVAILABLE);
  const to = link ? `${window.location.origin}/machine/${id}` : undefined;
  const text = data.atm?.name || NOT_AVAILABLE;
  const truncatedText = truncate ? truncateText(text, truncate) : text;

  return (
    <TableColumnClickableText
      sx={{
        '& h6': { maxWidth: 400, whiteSpace: 'normal', wordWrap: 'break-word' },
      }}
      id={id}
      to={to}
      text={truncatedText}
      fixIcon={fixIcon}
      clipboardValue={id}
      name="Machine ID"
      overrideTooltipLinkText="Go to Machine"
    />
  );
};

export default memo(TableColumnCashLogMachine);
